import React, { useState, useRef, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import './ChatSearch.css';

const ChatSearch = ({ value, onChange, placeholder = 'Search instruments...' }) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  // Keyboard shortcut: Cmd/Ctrl + F when panel is focused
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'f') {
        // Only if we're in the left panel context
        const leftPanel = document.querySelector('.left-panel');
        if (leftPanel?.contains(document.activeElement) || leftPanel?.matches(':hover')) {
          e.preventDefault();
          inputRef.current?.focus();
        }
      }
      // Escape to clear and blur
      if (e.key === 'Escape' && document.activeElement === inputRef.current) {
        onChange('');
        inputRef.current?.blur();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onChange]);

  const handleClear = () => {
    onChange('');
    inputRef.current?.focus();
  };

  return (
    <div className={`chat-search ${isFocused ? 'focused' : ''} ${value ? 'has-value' : ''}`}>
      <SearchIcon className="chat-search-icon" />
      <input
        ref={inputRef}
        type="text"
        className="chat-search-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        aria-label="Search instrument chats"
      />
      {value && (
        <button
          className="chat-search-clear"
          onClick={handleClear}
          aria-label="Clear search"
          type="button"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
};

export default ChatSearch;
